module.exports = __webpack_public_path__ + "img/diverse-workforces.41f4ef4b.webp";